import styled, { css } from 'styled-components';
import Logos from '@klv/organisms/logos';
import * as styles from '@klv/organisms/logos/styles/logos.module.scss';

export const StyledLogos = styled(Logos)`
  ${({ theme }) => css`
    background: transparent !important;
    padding-top: 0;
    padding-bottom: 0;
    .${styles.styledImage} {
      opacity: 0.65 !important;
    }
    .${styles.buttonsWrapper} {
      padding-bottom: 6.4rem;
      margin-top: 3.6rem;
    }
    ${styles.logoContainer} {
      row-gap: 3.2rem;
      ${theme.screenSize.s576.mediaQuery} {
        row-gap: 3.6rem;
      }
    }
  `}
`;
